export default __webpack_public_path__ + "static/media/alert_ticket.47bfd643.svg";